export function createAsideModal(cfg) {
  cfg.el.find('.close-btn').click(function() {
    self.hide();
  });

  if(cfg.size){
    cfg.el.find('.content').eq(0).css({width:`${cfg.size}px`,left:'unset'})
  }
  if(cfg.el.find('.aside-modal-shadow').length<1)
    cfg.el.prepend($('<div>').attr({class:'aside-modal-shadow'}).click(function(){
      self.hide();
    }));

  $(document).keyup(function (e) {
    let code = e.which || e.keyCode;
    if(code === 27) self.hide();
  });

  let self = {
    show: function() {
      cfg.el.addClass('visible');
    },
    hide: function() {
      cfg.el.removeClass('visible');
    },
    getEl: function () {
      return cfg.el;
    }
  };

  return self;
}
window.createAsideModal = createAsideModal;